<app-card-item
  [baseData]="baseData"
  [detailsLeft]="detailsLeft"
  [detailsRight]="detailsRight"
  [canHover]="baseData?.record?.id !== ''"
  (actionNavigate)="openItemInfo()">
  <ng-template appRecordButtons>
    <div>
      <opac-button type="tertiary" (click)="handleSuggestionToDelete(suggestionItem)" appStopPropagation
        >{{ 'button.remove' | translate }}</opac-button
      >
    </div>
  </ng-template>
</app-card-item>

<opac-confirmation-dialog
  [acceptLabel]="'common.delete'"
  [cancelLabel]="'common.cancel'"
  [open]="showDeleteSuggestionDialog()"
  [title]="'results.suggestions.cancel' | translate"
  (accept)="deleteSuggestion()"
  (cancel)="showDeleteSuggestionDialog.set(false)">
  <p>{{ 'suggestions.cancelConfirmation.body' | translate }}</p>
</opac-confirmation-dialog>